import React from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import possessive from 'lib/possessive'
import Layout from 'components/Layout/SplitLayout'
import HeaderOne from 'components/Headers/HeaderOne'
import HeaderThree from 'components/Headers/HeaderThree'
import Loader from 'components/Loader'
import Text from 'components/Text'
import {
  Form,
  Input,
  Button,
  ErrorText,
  Note,
  Checkbox,
} from 'components/Forms'
import PhoneInput from 'sharedComponents/Input/Phone'
import style from './style.module.scss'

InvitationPetParentEmailScreen.propTypes = {
  didAccept: PropTypes.bool,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isProcessing: PropTypes.bool,
  onSubmit: PropTypes.func,
  token: PropTypes.string,
  userdata: PropTypes.object,
}

function InvitationPetParentEmailScreen(props) {
  const { didAccept, error, isLoading, isProcessing, onSubmit, token, petParent, type } =
    props

  if (error) {
    return <ErrorText>{error}</ErrorText>
  }

  if (didAccept) {
    return <Redirect to={`/${type === 'email' ? 'pie' : 'pip'}/${token}/accepted`} push />
  }

  if (isLoading) {
    return <Loader />
  }
  const {firstName, lastName, email, phone, pet, user} = petParent

  return (
    <Layout showNav={false}>
      <HeaderOne className={style.header}>
        Hello {firstName} {lastName}
      </HeaderOne>
      <HeaderOne className={style.header}>
        Welcome to Pet Notify!
      </HeaderOne>

      <Form onSubmit={onSubmit}>
        {({ onChange, values, error }) =>
          isProcessing ? (
            <Loader />
          ) : (
            <React.Fragment>
              <Text className={style.smallHeader}>
                Thank you for accepting to be Pet parent of  {pet.name}.
              </Text>

              <Text className={style.disclosure}>
                In selecting &quot;I Agree&quot; you hereby accept Pet Notify <a href="https://www.petnotify.com/terms-of-use" target="_blank" className={style.link}>Terms of Use</a> and <a href="https://www.petnotify.com/privacy-policy" target="_blank" className={style.link}>Privacy Agreement</a>, and agree to receipt of Pet Notify email and SMS notifications when your pet needs help. Pet Notify will not share or use your contact information for any other purpose.
              </Text>

              <Checkbox
                name='agree'
                value={values.agree}
                onChange={onChange}
                label='I agree'
                id='agree'
              />

                {
                  type === 'email' && (<>
                    <HeaderThree className={style.phoneHeader}>
                      Email
                    </HeaderThree>
                    <Text className={style.text}>
                      {email}
                    </Text>
                  </>)
                }

                {
                  type === 'phone' && (<>
                    <HeaderThree className={style.phoneHeader}>
                      Mobile phone
                    </HeaderThree>
                    <Text className={style.text}>
                      {phone}
                    </Text>
                  </>)
                }
              


              {error && <ErrorText>{error}</ErrorText>}

              <Button type='submit' className={style.button}>
                Confirm
              </Button>
            </React.Fragment>
          )
        }
      </Form>

      <Text className={style.smallHeader}>What is Pet Notify?</Text>

      <Text className={style.text}>
        Pet Notify is a service that protects pets and pet parents. In
        the event the pet or pet parent requires emergency assistance, an SMS and email notification will be sent to you.
      </Text>

      <Button
        href='https://www.petnotify.com'
        target='_blank'
        variant='hollow'
        className={style.learnMoreButton}
      >
        Learn more
      </Button>
    </Layout>
  )
}
export default InvitationPetParentEmailScreen
